"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Collapse = exports.AccordionContext = void 0;
var react_1 = __importStar(require("react"));
var react_bootstrap_1 = require("react-bootstrap");
var __1 = require("../../");
var classnames_1 = __importDefault(require("classnames"));
require("./SzAccordion.scss");
var defaultValues = {
    activeKey: '0'
};
exports.AccordionContext = react_1.createContext(defaultValues);
function SzAccordion(props) {
    return (react_1.default.createElement(exports.AccordionContext.Provider, __assign({ value: props }, props),
        react_1.default.createElement(react_bootstrap_1.Accordion, { className: "sz-accordion", defaultActiveKey: props.activeKey }, props.children)));
}
function Collapse(_a) {
    var header = _a.header, body = _a.body, _b = _a.isDisabled, isDisabled = _b === void 0 ? false : _b, footer = _a.footer, eventKey = _a.eventKey, message = _a.message, _c = _a.onClick, onClick = _c === void 0 ? function () { } : _c;
    var activeKey = react_1.useContext(exports.AccordionContext).activeKey;
    var headerClasses = 'sz-collapse__header sz-left-border position-relative row align-items-stretch no-gutters pl-4 py-1';
    var headerContentClasses = classnames_1.default('col my-3 py-1', {
        'border-right': !isDisabled
    });
    var toggleButtonClasses = 'py-0 px-3 my-auto mx-2';
    var chevron = activeKey === eventKey ? 'subtract-square' : 'add-square';
    function ToggleHeader() {
        return isDisabled ? (react_1.default.createElement("div", { className: toggleButtonClasses },
            react_1.default.createElement(__1.SzTooltip, { content: message },
                react_1.default.createElement(__1.SzIcon, { variant: "line", icon: "information-circle", className: "text-inactive px-3" })))) : (react_1.default.createElement(react_bootstrap_1.Accordion.Toggle, { className: toggleButtonClasses, as: "div", onClick: function () { return onClick(eventKey); }, eventKey: eventKey },
            react_1.default.createElement(__1.SzButton, { variant: "tertiary", icon: chevron })));
    }
    return (react_1.default.createElement(react_bootstrap_1.Card, { className: "sz-collapse mb-3 border-0" },
        react_1.default.createElement("div", { className: headerClasses },
            react_1.default.createElement("div", { className: headerContentClasses }, header),
            react_1.default.createElement(ToggleHeader, null)),
        !isDisabled && (react_1.default.createElement(react_bootstrap_1.Accordion.Collapse, { eventKey: eventKey },
            react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(react_bootstrap_1.Card.Body, { className: "sz-collapse__body p-0" }, body),
                footer && (react_1.default.createElement(react_bootstrap_1.Card.Footer, { className: "sz-collapse__footer p-0 bg-white" }, footer)))))));
}
exports.Collapse = Collapse;
SzAccordion.SzCollapse = Collapse;
exports.default = SzAccordion;
